// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__17Zbu","gfeWrapper":"CalendarEvent_gfeWrapper__2oARR"};